module.exports = __webpack_public_path__ + "themes/fq/img/button-hover.png";


//////////////////
// WEBPACK FOOTER
// ./themes/fq/img/button-hover.png
// module id = 5
// module chunks = d-game